const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (window.BAO.MediaBreakpoints.isMd) return

    if (!this.els?.link?.exists) return

    this.init()
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('wheel', this.handleWheelEvent, { passive: false })
  }

  handleWheelEvent (e) {
    const delta = e.deltaY
    const isScrollingUp = delta < 0
    const isScrollingDown = delta > 0

    const pageScrollTop = window.scrollY
    const pageHeight = document.documentElement.scrollHeight
    const viewportHeight = window.innerHeight
    const atPageTop = pageScrollTop === 0
    const atPageBottom = pageScrollTop + viewportHeight >= pageHeight

    const galleryScrollTop = this.scrollTop
    const galleryMaxScroll = this.scrollHeight - this.clientHeight
    const atGalleryBottom =
      Math.ceil(galleryScrollTop) >= Math.floor(galleryMaxScroll)

    // Handle page scroll first when scrolling up or if the gallery is at the bottom
    if (
      (isScrollingUp && !atPageTop) ||
      (isScrollingDown && atGalleryBottom && !atPageBottom)
    ) {
      e.preventDefault()
      window.scrollBy(0, delta)
    }
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addPreviousButton()
      this.addNextButton()
      this.addCloseButton()
    })

    this.photoSwipeInstance.on('openingAnimationStart', () => {
      document.body.classList.add('pswp--loading')
    })

    this.photoSwipeInstance.on('openingAnimationEnd', () => {
      window.setTimeout(() => {
        document.body.classList.remove('pswp--loading')
      }, 1000)
    })
  }

  async init () {
    await this.setupHrefs()

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      showHideAnimationType: 'fade',
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 0.5,
      maxZoomLevel: 0.5,
      scaleMode: 'zoom',

      gallery: this.localName,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,

      closeOnVerticalDrag: false,
      closeOnScroll: false,

      tapAction: 'zoom',
      spacing: 0,

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.updateImageAttributes()

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  async setupHrefs () {
    // To prevent users being able to click on the image in a new tab
    // before the page is fully loaded, we set the href to the data-href
    // attribute.

    // eslint-disable-next-line compat/compat
    await Promise.all(
      this.els.link.elements.map(async (el, index) => {
        el.href = el.dataset.href
        el.target = '_blank'
      }),
    )
  }

  updateImageAttributes () {
    const mobileWidth = window.innerWidth
    const mobileHeight = window.innerHeight

    this.els.link.elements.forEach(el => {
      if (mobileWidth > mobileHeight) {
        const imageWidth = parseInt(el.dataset.pswpWidth, 10)
        const mobileRatio = imageWidth / window.innerWidth
        const imageHeight = parseInt(window.innerHeight * mobileRatio, 10)

        el.dataset.pswpWidth = imageWidth
        el.dataset.pswpHeight = imageHeight
      } else {
        const imageHeight = parseInt(el.dataset.pswpHeight, 10)
        const mobileRatio = imageHeight / window.innerHeight
        const imageWidth = parseInt(window.innerWidth * mobileRatio, 10)

        el.dataset.pswpWidth = imageWidth
        el.dataset.pswpHeight = imageHeight
      }
    })
  }

  addPreviousButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev()
      },
    })
  }

  addNextButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next()
      },
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  get arrowSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15"><path fill="currentColor" stroke="currentColor" stroke-width="1.2" d="m7.07 7.69.062-.19-.063-.19-.487-1.461L9.334 7.5 6.582 9.151 7.07 7.69Z"/></svg>`
  }

  get closeSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 15"><path fill="currentColor" fill-rule="evenodd" d="m8.707 7.5 2.829-2.829-.707-.707L8 6.793 5.172 3.964l-.707.707L7.293 7.5l-2.828 2.828.707.707L8 8.207l2.829 2.828.707-.707L8.707 7.5Z" clip-rule="evenodd"/></svg>`
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
